/*
    AGE_GR Points : 연령
     40 : 0   
     50 : 41
     60 : 75
     70 : 95
     80 : 100
*/
export const ageCul = (age) => {
  let ageData = 0;
  if (age.value < 50) {
    ageData = 0;
  } else if (50 <= age.value && age.value < 60) {
    ageData = 41;
  } else if (60 <= age.value && age.value < 70) {
    ageData = 75;
  } else if (70 <= age.value && age.value < 80) {
    ageData = 95;
  } else if (age.value >= 80) {
    ageData = 100;
  }
  return ageData;
};

/*
    AGE_GR Points : 연령
     40 : 0   
     50 : 41
     60 : 75
     70 : 95
     80 : 100
*/
export const ageCanCul = (age) => {
  let ageData = 0;
  if (age < 50) {
    ageData = 0;
  } else if (50 <= age && age < 60) {
    ageData = 41;
  } else if (60 <= age && age < 70) {
    ageData = 75;
  } else if (70 <= age && age < 80) {
    ageData = 95;
  } else if (age >= 80) {
    ageData = 100;
  }
  return ageData;
};

/*
    AGE_GR Points : 전립선암 연령
    
*/
export const ageProstateCul = (age) => {
  let ageData = 0;
  if (age.value < 50) {
    ageData = 0;
  } else if (50 <= age.value && age.value < 60) {
    ageData = 51;
  } else if (60 <= age.value && age.value < 70) {
    ageData = 85;
  } else if (70 <= age.value && age.value < 80) {
    ageData = 98;
  } else if (age.value >= 80) {
    ageData = 100;
  }
  return ageData;
};

/*
    AGE_GR Points : 전립선암 연령
    
*/
export const ageProstate = (age) => {
  let ageData = 0;
  if (age < 50) {
    ageData = 0;
  } else if (50 <= age && age < 60) {
    ageData = 51;
  } else if (60 <= age && age < 70) {
    ageData = 85;
  } else if (70 <= age && age < 80) {
    ageData = 98;
  } else if (age >= 80) {
    ageData = 100;
  }
  return ageData;
};

/*
     HPYN Points : 고혈압
*/
export const hpynProstateCul = (data) => {
  let hpyn = 0;
  if (data) {
    hpyn = 3;
  }
  return hpyn;
};

/*
      PA_REGULAR Points : 운동량
*/
export const paProstateCul = (data) => {
  let pa = 0;
  if (data) {
    pa = 2;
  }
  return pa;
};

export const ageCheck = (age) => {
  let ageData;
  if (age.value < 5) {
    ageData = 4;
  } else if (5 <= age.value && age.value < 10) {
    ageData = 9;
  } else if (10 <= age.value && age.value < 15) {
    ageData = 14;
  } else if (15 <= age.value && age.value < 20) {
    ageData = 19;
  } else if (20 <= age.value && age.value < 25) {
    ageData = 24;
  } else if (25 <= age.value && age.value < 30) {
    ageData = 29;
  } else if (30 <= age.value && age.value < 35) {
    ageData = 34;
  } else if (35 <= age.value && age.value < 40) {
    ageData = 39;
  } else if (40 <= age.value && age.value < 45) {
    ageData = 44;
  } else if (45 <= age.value && age.value < 50) {
    ageData = 49;
  } else if (50 <= age.value && age.value < 55) {
    ageData = 54;
  } else if (55 <= age.value && age.value < 60) {
    ageData = 59;
  } else if (60 <= age.value && age.value < 65) {
    ageData = 64;
  } else if (65 <= age.value && age.value < 70) {
    ageData = 69;
  } else if (70 <= age.value && age.value < 75) {
    ageData = 74;
  } else if (75 <= age.value && age.value < 80) {
    ageData = 79;
  } else if (80 <= age.value && age.value < 85) {
    ageData = 84;
  } else {
    ageData = 85;
  }
  return ageData;
};

// 성별 체크 : 남자면 21점 , 여자면 0점
export const genCul = (sex) => {
  let ageData;
  if (sex) {
    ageData = 21;
  } else {
    ageData = 0;
  }
  return ageData;
};

/*
   DMYN Points : 당뇨
    유 : 3
    무 : 0
*/
export const que1Cul = (data) => {
  let ageData;
  if (data) {
    ageData = 3;
  } else {
    ageData = 0;
  }
  return ageData;
};

/*
   DMYN Points : 당뇨
    유 : 3
    무 : 0
*/
export const que1CulPro = (data) => {
  let ageData;
  if (data) {
    ageData = 0;
  } else {
    ageData = 3;
  }
  return ageData;
};
/*
 PYE_G_P Points : 페기종
  유 : 20
  무 : 0
*/
export const que2Cul = (data) => {
  let ageData;
  if (data) {
    ageData = 20;
  } else {
    ageData = 0;
  }
  return ageData;
};

/*
  TB_SICK Points : 결핵 
  유 : 11
  무 : 0
*/
export const que3Cul = (data) => {
  let ageData;
  if (data) {
    ageData = 11;
  } else {
    ageData = 0;
  }
  return ageData;
};

/*
   SMOKING_GR Points : 흡연력 
    0: 0 
    1: 4
    10: 13
    20: 24
    30: 41 
*/
export const que4Cul = (data, year, gap) => {
  let ageData;
  const gapCul = gap * year;
  if (data) {
    if (gapCul >= 1 && gapCul < 10) {
      ageData = 4;
    } else if (10 <= gapCul && gapCul < 20) {
      ageData = 13;
    } else if (20 <= gapCul && gapCul < 30) {
      ageData = 24;
    } else if (30 <= gapCul) {
      ageData = 41;
    } else if (gapCul < 1) {
      ageData = 4;
    }
  } else {
    ageData = 0;
  }
  return ageData;
};

/*
   SMOKING_GR Points : 흡연력 
    0: 3 
    1: 1
    10: 0
    20: 1
    30: 0 
*/
export const smokingProstateCul = (data, year, gap) => {
  let ageData = 3;
  const gapCul = gap * year;
  if (data) {
    if (gapCul < 1) {
      ageData = 1;
    } else if (gapCul >= 1 && gapCul < 10) {
      ageData = 1;
    } else if (10 <= gapCul && gapCul < 20) {
      ageData = 0;
    } else if (20 <= gapCul && gapCul < 30) {
      ageData = 1;
    } else {
      ageData = 0;
    } 
  }
  return ageData;
};

/* 
  BMI_5LEVEL Points 
  1: 24
  2: 15
  3: 8
  4: 5
  5: 0
*/
export const bmi = (kg, cm) => {
  let ageData;
  let data = kg / Math.pow(cm / 100, 2);
  if (data < 18.5) {
    ageData = 24;
  } else if (18.5 <= data && data < 23) {
    ageData = 15;
  } else if (23 <= data && data < 25) {
    ageData = 8;
  } else if (25 <= data && data < 30) {
    ageData = 5;
  } else {
    ageData = 0;
  }

  return ageData;
};

/* 
  BMI_5LEVEL Points 
  1: 0
  2: 6
  3: 9
  4: 10
  5: 11
*/
export const bmiProstate = (kg, cm) => {
  let ageData;
  let data = kg / Math.pow(cm / 100, 2);
  if (data < 18.5) {
    ageData = 0;
  } else if (18.5 <= data && data < 23) {
    ageData = 6;
  } else if (23 <= data && data < 25) {
    ageData = 9;
  } else if (25 <= data && data < 30) {
    ageData = 10;
  } else {
    ageData = 11;
  }

  return ageData;
};

/* 
  BMI_5LEVEL Points Breast
  1: 0
  2: 13
  3: 17
  4: 24
  5: 34
*/
export const bmiBreast = (kg, cm) => {
  let ageData;
  let data = kg / Math.pow(cm / 100, 2);
  if (data < 18.5) {
    ageData = 0;
  } else if (18.5 <= data && data < 23) {
    ageData = 13;
  } else if (23 <= data && data < 25) {
    ageData = 17;
  } else if (25 <= data && data < 30) {
    ageData = 24;
  } else {
    ageData = 34;
  }

  return ageData;
};

export const yearOneCase = (score) => {
  let count = 0.998;
  if (score <= 122) {
    count = 0.998;
  } else if (122 < score && score <= 147) {
    count = 0.996;
  } else if (147 < score && score <= 162) {
    count = 0.994;
  } else if (162 < score && score <= 173) {
    count = 0.992;
  } else if (173 < score && score <= 181) {
    count = 0.99;
  } else if (181 < score && score <= 188) {
    count = 0.988;
  } else if (188 < score && score <= 193) {
    count = 0.986;
  } else if (193 < score && score <= 198) {
    count = 0.984;
  } else if (198 < score && score <= 203) {
    count = 0.982;
  } else if (203 < score && score <= 207) {
    count = 0.98;
  } else if (207 < score && score <= 210) {
    count = 0.978;
  } else if (210 < score && score <= 213) {
    count = 0.976;
  } else if (213 < score && score <= 216) {
    count = 0.974;
  } else if (216 < score && score <= 219) {
    count = 0.972;
  } else if (219 < score && score <= 222) {
    count = 0.97;
  } else if (222 < score && score <= 224) {
    count = 0.968;
  } else if (224 < score && score <= 226) {
    count = 0.966;
  } else if (226 < score && score <= 228) {
    count = 0.964;
  } else if (228 < score && score <= 230) {
    count = 0.962;
  }
  return count;
};
export const yearTwoCase = (score) => {
  let count = 0.998;
  if (score <= 95) {
    count = 0.998;
  } else if (95 < score && score <= 120) {
    count = 0.996;
  } else if (120 < score && score <= 135) {
    count = 0.994;
  } else if (135 < score && score <= 146) {
    count = 0.992;
  } else if (146 < score && score <= 154) {
    count = 0.99;
  } else if (154 < score && score <= 161) {
    count = 0.988;
  } else if (161 < score && score <= 167) {
    count = 0.986;
  } else if (167 < score && score <= 172) {
    count = 0.984;
  } else if (172 < score && score <= 176) {
    count = 0.982;
  } else if (176 < score && score <= 180) {
    count = 0.98;
  } else if (180 < score && score <= 183) {
    count = 0.978;
  } else if (183 < score && score <= 187) {
    count = 0.976;
  } else if (187 < score && score <= 190) {
    count = 0.974;
  } else if (190 < score && score <= 192) {
    count = 0.972;
  } else if (192 < score && score <= 195) {
    count = 0.97;
  } else if (195 < score && score <= 197) {
    count = 0.968;
  } else if (197 < score && score <= 200) {
    count = 0.966;
  } else if (200 < score && score <= 202) {
    count = 0.964;
  } else if (202 < score && score <= 204) {
    count = 0.962;
  } else if (204 < score && score <= 206) {
    count = 0.96;
  } else if (206 < score && score <= 208) {
    count = 0.958;
  } else if (208 < score && score <= 209) {
    count = 0.956;
  } else if (209 < score && score <= 211) {
    count = 0.954;
  } else if (211 < score && score <= 213) {
    count = 0.952;
  } else if (213 < score && score <= 214) {
    count = 0.95;
  } else if (214 < score && score <= 216) {
    count = 0.948;
  } else if (216 < score && score <= 217) {
    count = 0.946;
  } else if (217 < score && score <= 218) {
    count = 0.944;
  } else if (218 < score && score <= 220) {
    count = 0.942;
  } else if (220 < score && score <= 221) {
    count = 0.94;
  } else if (221 < score && score <= 222) {
    count = 0.938;
  } else if (222 < score && score <= 223) {
    count = 0.936;
  } else if (223 < score && score <= 225) {
    count = 0.934;
  } else if (225 < score && score <= 226) {
    count = 0.932;
  } else if (226 < score && score <= 227) {
    count = 0.93;
  } else if (227 < score && score <= 228) {
    count = 0.928;
  } else if (228 < score && score <= 229) {
    count = 0.926;
  } else if (229 < score && score <= 230) {
    count = 0.924;
  } else if (230 < score && score <= 231) {
    count = 0.962;
  }
  return count;
};
export const yearThreeCase = (score) => {
  let count = 0.998;
  if (score <= 78) {
    count = 0.998;
  } else if (78 < score && score <= 104) {
    count = 0.996;
  } else if (104 < score && score <= 119) {
    count = 0.994;
  } else if (119 < score && score <= 129) {
    count = 0.992;
  } else if (129 < score && score <= 138) {
    count = 0.99;
  } else if (138 < score && score <= 144) {
    count = 0.988;
  } else if (144 < score && score <= 150) {
    count = 0.986;
  } else if (150 < score && score <= 155) {
    count = 0.984;
  } else if (155 < score && score <= 159) {
    count = 0.982;
  } else if (159 < score && score <= 163) {
    count = 0.98;
  } else if (163 < score && score <= 167) {
    count = 0.978;
  } else if (167 < score && score <= 170) {
    count = 0.976;
  } else if (170 < score && score <= 173) {
    count = 0.974;
  } else if (173 < score && score <= 176) {
    count = 0.972;
  } else if (176 < score && score <= 178) {
    count = 0.97;
  } else if (178 < score && score <= 181) {
    count = 0.968;
  } else if (181 < score && score <= 183) {
    count = 0.966;
  } else if (183 < score && score <= 185) {
    count = 0.964;
  } else if (185 < score && score <= 187) {
    count = 0.962;
  } else if (187 < score && score <= 189) {
    count = 0.96;
  } else if (189 < score && score <= 191) {
    count = 0.958;
  } else if (191 < score && score <= 193) {
    count = 0.956;
  } else if (193 < score && score <= 194) {
    count = 0.954;
  } else if (194 < score && score <= 196) {
    count = 0.952;
  } else if (196 < score && score <= 197) {
    count = 0.95;
  } else if (197 < score && score <= 199) {
    count = 0.948;
  } else if (199 < score && score <= 200) {
    count = 0.946;
  } else if (200 < score && score <= 202) {
    count = 0.944;
  } else if (202 < score && score <= 203) {
    count = 0.942;
  } else if (203 < score && score <= 204) {
    count = 0.94;
  } else if (204 < score && score <= 206) {
    count = 0.938;
  } else if (206 < score && score <= 207) {
    count = 0.936;
  } else if (207 < score && score <= 208) {
    count = 0.934;
  } else if (208 < score && score <= 209) {
    count = 0.932;
  } else if (209 < score && score <= 210) {
    count = 0.93;
  } else if (210 < score && score <= 211) {
    count = 0.928;
  } else if (211 < score && score <= 212) {
    count = 0.926;
  } else if (212 < score && score <= 213) {
    count = 0.924;
  } else if (213 < score && score <= 214) {
    count = 0.922;
  } else if (214 < score && score <= 215) {
    count = 0.92;
  } else if (215 < score && score <= 216) {
    count = 0.918;
  } else if (216 < score && score <= 217) {
    count = 0.916;
  } else if (217 < score && score <= 218) {
    count = 0.914;
  } else if (218 < score && score <= 219) {
    count = 0.912;
  } else if (219 < score && score <= 220) {
    count = 0.91;
  } else if (220 < score && score <= 221) {
    count = 0.908;
  } else if (221 < score && score <= 222) {
    count = 0.904;
  } else if (222 < score && score <= 223) {
    count = 0.902;
  } else if (223 < score && score <= 224) {
    count = 0.9;
  } else if (224 < score && score <= 225) {
    count = 0.896;
  } else if (225 < score && score <= 226) {
    count = 0.894;
  } else if (226 < score && score <= 227) {
    count = 0.892;
  } else if (227 < score && score <= 228) {
    count = 0.888;
  } else if (228 < score && score <= 229) {
    count = 0.886;
  } else if (229 < score && score <= 230) {
    count = 0.882;
  } else if (230 < score && score <= 231) {
    count = 0.88;
  }
  return count;
};

export const yearFourCase = (score) => {
  let count = 0.998;
  if (score <= 67) {
    count = 0.998;
  } else if (67 < score && score <= 92) {
    count = 0.996;
  } else if (92 < score && score <= 107) {
    count = 0.994;
  } else if (107 < score && score <= 118) {
    count = 0.992;
  } else if (118 < score && score <= 126) {
    count = 0.99;
  } else if (126 < score && score <= 133) {
    count = 0.988;
  } else if (133 < score && score <= 138) {
    count = 0.986;
  } else if (138 < score && score <= 143) {
    count = 0.984;
  } else if (143 < score && score <= 148) {
    count = 0.982;
  } else if (148 < score && score <= 152) {
    count = 0.98;
  } else if (152 < score && score <= 155) {
    count = 0.978;
  } else if (155 < score && score <= 158) {
    count = 0.976;
  } else if (158 < score && score <= 161) {
    count = 0.974;
  } else if (161 < score && score <= 164) {
    count = 0.972;
  } else if (164 < score && score <= 167) {
    count = 0.97;
  } else if (167 < score && score <= 169) {
    count = 0.968;
  } else if (169 < score && score <= 171) {
    count = 0.966;
  } else if (171 < score && score <= 174) {
    count = 0.964;
  } else if (174 < score && score <= 176) {
    count = 0.962;
  } else if (176 < score && score <= 178) {
    count = 0.96;
  } else if (178 < score && score <= 179) {
    count = 0.958;
  } else if (179 < score && score <= 181) {
    count = 0.956;
  } else if (181 < score && score <= 183) {
    count = 0.954;
  } else if (183 < score && score <= 184) {
    count = 0.952;
  } else if (184 < score && score <= 186) {
    count = 0.95;
  } else if (186 < score && score <= 187) {
    count = 0.948;
  } else if (187 < score && score <= 189) {
    count = 0.946;
  } else if (189 < score && score <= 190) {
    count = 0.944;
  } else if (190 < score && score <= 192) {
    count = 0.942;
  } else if (192 < score && score <= 193) {
    count = 0.94;
  } else if (193 < score && score <= 194) {
    count = 0.938;
  } else if (194 < score && score <= 195) {
    count = 0.936;
  } else if (195 < score && score <= 196) {
    count = 0.934;
  } else if (196 < score && score <= 198) {
    count = 0.932;
  } else if (198 < score && score <= 199) {
    count = 0.93;
  } else if (199 < score && score <= 200) {
    count = 0.928;
  } else if (200 < score && score <= 201) {
    count = 0.926;
  } else if (201 < score && score <= 202) {
    count = 0.924;
  } else if (202 < score && score <= 203) {
    count = 0.922;
  } else if (203 < score && score <= 204) {
    count = 0.92;
  } else if (204 < score && score <= 205) {
    count = 0.918;
  } else if (205 < score && score <= 206) {
    count = 0.916;
  } else if (206 < score && score <= 207) {
    count = 0.914;
  } else if (207 < score && score <= 208) {
    count = 0.912;
  } else if (208 < score && score <= 209) {
    count = 0.91;
  } else if (209 < score && score <= 210) {
    count = 0.908;
  } else if (210 < score && score <= 211) {
    count = 0.904;
  } else if (211 < score && score <= 212) {
    count = 0.902;
  } else if (212 < score && score <= 213) {
    count = 0.898;
  } else if (213 < score && score <= 214) {
    count = 0.896;
  } else if (214 < score && score <= 215) {
    count = 0.894;
  } else if (215 < score && score <= 216) {
    count = 0.89;
  } else if (216 < score && score <= 217) {
    count = 0.888;
  } else if (217 < score && score <= 218) {
    count = 0.884;
  } else if (218 < score && score <= 219) {
    count = 0.882;
  } else if (219 < score && score <= 220) {
    count = 0.878;
  } else if (220 < score && score <= 221) {
    count = 0.876;
  } else if (221 < score && score <= 222) {
    count = 0.872;
  } else if (222 < score && score <= 223) {
    count = 0.87;
  } else if (223 < score && score <= 224) {
    count = 0.866;
  } else if (224 < score && score <= 225) {
    count = 0.862;
  } else if (225 < score && score <= 226) {
    count = 0.86;
  } else if (226 < score && score <= 227) {
    count = 0.856;
  } else if (227 < score && score <= 228) {
    count = 0.852;
  } else if (228 < score && score <= 229) {
    count = 0.848;
  } else if (229 < score && score <= 230) {
    count = 0.844;
  } else if (230 < score && score <= 231) {
    count = 0.84;
  }

  return count;
};

export const yearFiveCase = (score) => {
  let count = 0.998;
  if (score <= 57) {
    count = 0.998;
  } else if (57 < score && score <= 83) {
    count = 0.996;
  } else if (83 < score && score <= 98) {
    count = 0.994;
  } else if (98 < score && score <= 108) {
    count = 0.992;
  } else if (108 < score && score <= 116) {
    count = 0.99;
  } else if (116 < score && score <= 123) {
    count = 0.988;
  } else if (123 < score && score <= 129) {
    count = 0.986;
  } else if (129 < score && score <= 134) {
    count = 0.984;
  } else if (134 < score && score <= 138) {
    count = 0.982;
  } else if (138 < score && score <= 142) {
    count = 0.98;
  } else if (142 < score && score <= 146) {
    count = 0.978;
  } else if (146 < score && score <= 149) {
    count = 0.976;
  } else if (149 < score && score <= 152) {
    count = 0.974;
  } else if (152 < score && score <= 155) {
    count = 0.972;
  } else if (155 < score && score <= 157) {
    count = 0.97;
  } else if (157 < score && score <= 160) {
    count = 0.968;
  } else if (160 < score && score <= 162) {
    count = 0.966;
  } else if (162 < score && score <= 164) {
    count = 0.964;
  } else if (164 < score && score <= 166) {
    count = 0.962;
  } else if (166 < score && score <= 168) {
    count = 0.96;
  } else if (168 < score && score <= 170) {
    count = 0.958;
  } else if (170 < score && score <= 172) {
    count = 0.956;
  } else if (172 < score && score <= 173) {
    count = 0.954;
  } else if (173 < score && score <= 175) {
    count = 0.952;
  } else if (175 < score && score <= 176) {
    count = 0.95;
  } else if (176 < score && score <= 178) {
    count = 0.948;
  } else if (178 < score && score <= 179) {
    count = 0.946;
  } else if (179 < score && score <= 181) {
    count = 0.944;
  } else if (181 < score && score <= 182) {
    count = 0.942;
  } else if (182 < score && score <= 183) {
    count = 0.94;
  } else if (183 < score && score <= 184) {
    count = 0.938;
  } else if (185 < score && score <= 186) {
    count = 0.936;
  } else if (186 < score && score <= 187) {
    count = 0.934;
  } else if (187 < score && score <= 188) {
    count = 0.932;
  } else if (188 < score && score <= 189) {
    count = 0.93;
  } else if (189 < score && score <= 190) {
    count = 0.928;
  } else if (190 < score && score <= 191) {
    count = 0.926;
  } else if (191 < score && score <= 192) {
    count = 0.924;
  } else if (192 < score && score <= 193) {
    count = 0.922;
  } else if (193 < score && score <= 194) {
    count = 0.92;
  } else if (194 < score && score <= 195) {
    count = 0.918;
  } else if (195 < score && score <= 196) {
    count = 0.916;
  } else if (196 < score && score <= 197) {
    count = 0.914;
  } else if (197 < score && score <= 198) {
    count = 0.912;
  } else if (198 < score && score <= 199) {
    count = 0.91;
  } else if (199 < score && score <= 200) {
    count = 0.904;
  } else if (200 < score && score <= 201) {
    count = 0.902;
  } else if (201 < score && score <= 202) {
    count = 0.898;
  } else if (202 < score && score <= 203) {
    count = 0.896;
  } else if (203 < score && score <= 204) {
    count = 0.894;
  } else if (204 < score && score <= 205) {
    count = 0.89;
  } else if (205 < score && score <= 206) {
    count = 0.888;
  } else if (206 < score && score <= 207) {
    count = 0.884;
  } else if (207 < score && score <= 208) {
    count = 0.882;
  } else if (208 < score && score <= 209) {
    count = 0.878;
  } else if (209 < score && score <= 210) {
    count = 0.876;
  } else if (210 < score && score <= 211) {
    count = 0.872;
  } else if (211 < score && score <= 212) {
    count = 0.87;
  } else if (212 < score && score <= 213) {
    count = 0.866;
  } else if (213 < score && score <= 214) {
    count = 0.862;
  } else if (214 < score && score <= 215) {
    count = 0.86;
  } else if (215 < score && score <= 216) {
    count = 0.856;
  } else if (216 < score && score <= 217) {
    count = 0.852;
  } else if (217 < score && score <= 218) {
    count = 0.848;
  } else if (218 < score && score <= 219) {
    count = 0.844;
  } else if (219 < score && score <= 220) {
    count = 0.84;
  } else if (220 < score && score <= 221) {
    count = 0.84;
  } else if (221 < score && score <= 222) {
    count = 0.84;
  } else if (222 < score && score <= 223) {
    count = 0.84;
  } else if (223 < score && score <= 224) {
    count = 0.84;
  } else if (224 < score && score <= 225) {
    count = 0.84;
  } else if (225 < score && score <= 226) {
    count = 0.84;
  } else if (226 < score && score <= 227) {
    count = 0.84;
  } else if (227 < score && score <= 228) {
    count = 0.84;
  } else if (228 < score && score <= 229) {
    count = 0.84;
  } else if (229 < score && score <= 230) {
    count = 0.84;
  } else if (230 < score && score <= 231) {
    count = 0.84;
  }

  return count;
};

const year9Arr = [
  [0, "0"],
  [30, "0.200"],
  [55, "0.400"],
  [70, "0.600"],
  [81, "0.800"],
  [89, "1.000"],
  [96, "1.200"],
  [101, "1.400"],
  [106, "1.600"],
  [111, "1.800"],
  [115, "2.000"],
  [118, "2.200"],
  [118, "2.400"],
  [121, "2.600"],
  [124, "2.800"],
  [127, "3.000"],
  [130, "3.200"],
  [132, "3.400"],
  [137, "3.600"],
  [139, "3.800"],
  [140, "4.000"],
  [142, "4.200"],
  [144, "4.400"],
  [146, "4.600"],
  [147, "4.800"],
  [149, "5.000"],
  [150, "5.200"],
  [152, "5.400"],
  [153, "5.600"],
  [154, "5.800"],
  [156, "6.000"],
  [157, "6.200"],
  [158, "6.400"],
  [159, "6.600"],
  [160, "6.800"],
  [162, "7.000"],
  [163, "7.200"],
  [164, "7.400"],
  [165, "7.600"],
  [166, "7.800"],
  [167, "8.000"],
  [168, "8.200"],
  [169, "8.600"],
  [170, "8.800"],
  [171, "9.000"],
  [172, "9.200"],
  [173, "9.400"],
  [174, "9.600"],
  [175, "10.000"],
  [176, "10.200"],
  [177, "10.400"],
  [178, "10.800"],
  [179, "11.000"],
  [180, "11.400"],
  [181, "11.600"],
  [182, "12.000"],
  [183, "12.200"],
  [184, "12.600"],
  [185, "12.800"],
  [186, "13.200"],
  [187, "13.600"],
  [188, "14.000"],
  [189, "14.200"],
  [190, "14.600"],
  [191, "15.000"],
  [192, "15.400"],
  [193, "15.800"],
  [194, "16.200"],
  [195, "16.600"],
  [196, "17.000"],
  [197, "17.400"],
  [198, "17.800"],
  [199, "18.400"],
  [200, "18.800"],
  [201, "19.200"],
  [202, "19.800"],
  [203, "20.200"],
  [204, "20.800"],
  [205, "21.200"],
  [206, "21.800"],
  [207, "22.200"],
  [208, "22.800"],
  [209, "23.400"],
  [210, "24.000"],
  [211, "24.400"],
  [212, "25.000"],
  [213, "25.600"],
  [214, "26.200"],
  [215, "27.000"],
  [216, "27.600"],
  [217, "27.400"],
  [218, "28.800"],
  [219, "29.600"],
  [220, "30.200"],
  [221, "30.800"],
  [222, "31.600"],
  [223, "32.200"],
  [224, "33.000"],
  [225, "33.800"],
  [226, "34.600"],
  [227, "35.200"],
  [228, "36.000"],
  [229, "36.800"],
  [230, "37.600"],
  [231, "38.400"],
];
export const year9Case20220511 = (score) => {
  const filterData = year9Arr.filter((data, index) => {
    return score <= data[0];
  });

  if (filterData[0][0] === score) {
    return filterData[0][1].toString();
  } else {
    const nextData = filterData[0]; // 다음 스코어
    const prevData = year9Arr[year9Arr.length - filterData.length - 1];
    const preNum = parseFloat(prevData[1]);
    const nextNumData = parseFloat(nextData[1]);
    const totalResult =
      preNum +
      ((nextNumData - preNum) / (nextData[0] - prevData[0])) *
        (score - prevData[0]);
    return totalResult.toFixed(3);
  }
};
// 0.2 + (0.2)/(55-30)*(34- 30)
// 현재점수 + (위에퍼센트 - 이전퍼센트)/(위에점수 - 이전점수)*(현재점수-이전점수)

export const year9Case = (score) => {
  let count = 0.998;
  if (score <= 30) {
    count = 0.998;
  } else if (30 < score && score <= 55) {
    count = 0.996;
  } else if (55 < score && score <= 70) {
    count = 0.994;
  } else if (70 < score && score <= 81) {
    count = 0.992;
  } else if (81 < score && score <= 89) {
    count = 0.99;
  } else if (89 < score && score <= 96) {
    count = 0.988;
  } else if (96 < score && score <= 101) {
    count = 0.986;
  } else if (101 < score && score <= 106) {
    count = 0.984;
  } else if (106 < score && score <= 111) {
    count = 0.982;
  } else if (111 < score && score <= 115) {
    count = 0.98;
  } else if (115 < score && score <= 118) {
    count = 0.978;
  } else if (118 < score && score <= 121) {
    count = 0.976;
  } else if (121 < score && score <= 124) {
    count = 0.974;
  } else if (124 < score && score <= 127) {
    count = 0.972;
  } else if (127 < score && score <= 130) {
    count = 0.97;
  } else if (130 < score && score <= 132) {
    count = 0.968;
  } else if (132 < score && score <= 134) {
    count = 0.966;
  } else if (134 < score && score <= 137) {
    count = 0.964;
  } else if (137 < score && score <= 139) {
    count = 0.962;
  } else if (139 < score && score <= 140) {
    count = 0.96;
  } else if (140 < score && score <= 142) {
    count = 0.958;
  } else if (142 < score && score <= 144) {
    count = 0.956;
  } else if (144 < score && score <= 146) {
    count = 0.954;
  } else if (146 < score && score <= 147) {
    count = 0.952;
  } else if (147 < score && score <= 149) {
    count = 0.95;
  } else if (149 < score && score <= 150) {
    count = 0.948;
  } else if (150 < score && score <= 152) {
    count = 0.946;
  } else if (152 < score && score <= 153) {
    count = 0.944;
  } else if (153 < score && score <= 154) {
    count = 0.942;
  } else if (154 < score && score <= 156) {
    count = 0.94;
  } else if (156 < score && score <= 157) {
    count = 0.938;
  } else if (157 < score && score <= 158) {
    count = 0.936;
  } else if (158 < score && score <= 159) {
    count = 0.934;
  } else if (159 < score && score <= 160) {
    count = 0.932;
  } else if (160 < score && score <= 162) {
    count = 0.93;
  } else if (162 < score && score <= 163) {
    count = 0.928;
  } else if (163 < score && score <= 164) {
    count = 0.926;
  } else if (164 < score && score <= 165) {
    count = 0.924;
  } else if (165 < score && score <= 166) {
    count = 0.922;
  } else if (166 < score && score <= 167) {
    count = 0.92;
  } else if (167 < score && score <= 168) {
    count = 0.918;
  } else if (168 < score && score <= 169) {
    count = 0.914;
  } else if (169 < score && score <= 170) {
    count = 0.912;
  } else if (170 < score && score <= 171) {
    count = 0.91;
  } else if (171 < score && score <= 172) {
    count = 0.908;
  } else if (172 < score && score <= 173) {
    count = 0.906;
  } else if (173 < score && score <= 174) {
    count = 0.904;
  } else if (174 < score && score <= 175) {
    count = 0.9;
  } else if (175 < score && score <= 176) {
    count = 0.898;
  } else if (176 < score && score <= 177) {
    count = 0.896;
  } else if (177 < score && score <= 178) {
    count = 0.892;
  } else if (178 < score && score <= 179) {
    count = 0.89;
  } else if (179 < score && score <= 180) {
    count = 0.886;
  } else if (180 < score && score <= 181) {
    count = 0.884;
  } else if (181 < score && score <= 182) {
    count = 0.88;
  } else if (182 < score && score <= 183) {
    count = 0.878;
  } else if (183 < score && score <= 184) {
    count = 0.874;
  } else if (184 < score && score <= 185) {
    count = 0.872;
  } else if (185 < score && score <= 186) {
    count = 0.868;
  } else if (186 < score && score <= 187) {
    count = 0.864;
  } else if (187 < score && score <= 188) {
    count = 0.86;
  } else if (188 < score && score <= 189) {
    count = 0.858;
  } else if (189 < score && score <= 190) {
    count = 0.854;
  } else if (190 < score && score <= 191) {
    count = 0.85;
  } else if (191 < score && score <= 192) {
    count = 0.846;
  } else if (192 < score && score <= 193) {
    count = 0.842;
  } else if (193 < score && score <= 194) {
    count = 0.838;
  } else if (194 < score && score <= 195) {
    count = 0.834;
  } else if (195 < score && score <= 196) {
    count = 0.83;
  } else if (196 < score && score <= 197) {
    count = 0.826;
  } else if (197 < score && score <= 198) {
    count = 0.822;
  } else if (198 < score && score <= 199) {
    count = 0.816;
  } else if (199 < score && score <= 200) {
    count = 0.812;
  } else if (200 < score && score <= 201) {
    count = 0.808;
  } else if (201 < score && score <= 202) {
    count = 0.802;
  } else if (202 < score && score <= 203) {
    count = 0.798;
  } else if (203 < score && score <= 204) {
    count = 0.792;
  } else if (204 < score && score <= 205) {
    count = 0.788;
  } else if (205 < score && score <= 206) {
    count = 0.782;
  } else if (206 < score && score <= 207) {
    count = 0.778;
  } else if (207 < score && score <= 208) {
    count = 0.772;
  } else if (208 < score && score <= 209) {
    count = 0.766;
  } else if (209 < score && score <= 210) {
    count = 0.76;
  } else if (210 < score && score <= 211) {
    count = 0.756;
  } else if (211 < score && score <= 212) {
    count = 0.75;
  } else if (212 < score && score <= 213) {
    count = 0.744;
  } else if (213 < score && score <= 214) {
    count = 0.738;
  } else if (214 < score && score <= 215) {
    count = 0.73;
  } else if (215 < score && score <= 216) {
    count = 0.724;
  } else if (216 < score && score <= 217) {
    count = 0.718;
  } else if (217 < score && score <= 218) {
    count = 0.712;
  } else if (218 < score && score <= 219) {
    count = 0.704;
  } else if (219 < score && score <= 220) {
    count = 0.698;
  } else if (220 < score && score <= 221) {
    count = 0.692;
  } else if (221 < score && score <= 222) {
    count = 0.684;
  } else if (222 < score && score <= 223) {
    count = 0.678;
  } else if (223 < score && score <= 224) {
    count = 0.67;
  } else if (224 < score && score <= 225) {
    count = 0.662;
  } else if (225 < score && score <= 226) {
    count = 0.654;
  } else if (226 < score && score <= 227) {
    count = 0.648;
  } else if (227 < score && score <= 228) {
    count = 0.64;
  } else if (228 < score && score <= 229) {
    count = 0.632;
  } else if (229 < score && score <= 230) {
    count = 0.624;
  } else if (230 < score && score <= 231) {
    count = 0.616;
  }
  return count;
};

const prostate1yearCase = (score) => {
  let count = 0.999;
  if (score <= 82) {
    count = 0.999;
  } else if (82 < score && score <= 101) {
    count = 0.998;
  } else if (101 < score && score <= 112) {
    count = 0.997;
  } else if (112 < score && score <= 120) {
    count = 0.996;
  }
  return count;
};
const prostate2yearCase = (score) => {
  let count = 0.999;
  if (score <= 62) {
    count = 0.999;
  } else if (62 < score && score <= 81) {
    count = 0.998;
  } else if (101 < score && score <= 92) {
    count = 0.997;
  } else if (112 < score && score <= 99) {
    count = 0.996;
  } else if (112 < score && score <= 105) {
    count = 0.995;
  } else if (105 < score && score <= 110) {
    count = 0.994;
  } else if (110 < score && score <= 115) {
    count = 0.993;
  } else if (115 < score && score <= 118) {
    count = 0.992;
  } else if (118 < score && score <= 122) {
    count = 0.991;
  }
  return count;
};

const prostate3yearCase = (score) => {
  let count = 0.999;
  if (score <= 49) {
    count = 0.999;
  } else if (62 < score && score <= 68) {
    count = 0.998;
  } else if (68 < score && score <= 79) {
    count = 0.997;
  } else if (79 < score && score <= 87) {
    count = 0.996;
  } else if (87 < score && score <= 93) {
    count = 0.995;
  } else if (93 < score && score <= 98) {
    count = 0.994;
  } else if (98 < score && score <= 102) {
    count = 0.993;
  } else if (102 < score && score <= 106) {
    count = 0.992;
  } else if (106 < score && score <= 109) {
    count = 0.991;
  } else if (109 < score && score <= 112) {
    count = 0.99;
  } else if (112 < score && score <= 114) {
    count = 0.989;
  } else if (114 < score && score <= 117) {
    count = 0.988;
  } else if (117 < score && score <= 119) {
    count = 0.987;
  } else if (119 < score && score <= 121) {
    count = 0.986;
  }
  return count;
};

const prostate4yearCase = (score) => {
  let count = 0.999;
  if (score <= 40) {
    count = 0.999;
  } else if (40 < score && score <= 59) {
    count = 0.998;
  } else if (59 < score && score <= 70) {
    count = 0.997;
  } else if (70 < score && score <= 78) {
    count = 0.996;
  } else if (78 < score && score <= 84) {
    count = 0.995;
  } else if (84 < score && score <= 89) {
    count = 0.994;
  } else if (89 < score && score <= 93) {
    count = 0.993;
  } else if (93 < score && score <= 97) {
    count = 0.992;
  } else if (97 < score && score <= 100) {
    count = 0.991;
  } else if (100 < score && score <= 103) {
    count = 0.99;
  } else if (103 < score && score <= 105) {
    count = 0.989;
  } else if (105 < score && score <= 108) {
    count = 0.988;
  } else if (108 < score && score <= 110) {
    count = 0.987;
  } else if (110 < score && score <= 112) {
    count = 0.986;
  } else if (112 < score && score <= 114) {
    count = 0.985;
  } else if (114 < score && score <= 115) {
    count = 0.984;
  } else if (115 < score && score <= 117) {
    count = 0.983;
  } else if (117 < score && score <= 119) {
    count = 0.982;
  } else if (119 < score && score <= 120) {
    count = 0.981;
  } else if (120 < score && score <= 122) {
    count = 0.98;
  }
  return count;
};

const prostate5yearCase = (score) => {
  let count = 0.999;
  if (score <= 32) {
    count = 0.999;
  } else if (32 < score && score <= 51) {
    count = 0.998;
  } else if (51 < score && score <= 62) {
    count = 0.997;
  } else if (62 < score && score <= 70) {
    count = 0.996;
  } else if (70 < score && score <= 76) {
    count = 0.995;
  } else if (76 < score && score <= 81) {
    count = 0.994;
  } else if (81 < score && score <= 85) {
    count = 0.993;
  } else if (85 < score && score <= 89) {
    count = 0.992;
  } else if (89 < score && score <= 92) {
    count = 0.991;
  } else if (92 < score && score <= 95) {
    count = 0.99;
  } else if (95 < score && score <= 98) {
    count = 0.989;
  } else if (98 < score && score <= 100) {
    count = 0.988;
  } else if (100 < score && score <= 102) {
    count = 0.987;
  } else if (102 < score && score <= 104) {
    count = 0.986;
  } else if (104 < score && score <= 106) {
    count = 0.985;
  } else if (106 < score && score <= 108) {
    count = 0.984;
  } else if (108 < score && score <= 110) {
    count = 0.983;
  } else if (110 < score && score <= 111) {
    count = 0.982;
  } else if (111 < score && score <= 113) {
    count = 0.981;
  } else if (113 < score && score <= 114) {
    count = 0.98;
  } else if (114 < score && score <= 115) {
    count = 0.979;
  } else if (115 < score && score <= 117) {
    count = 0.978;
  } else if (117 < score && score <= 118) {
    count = 0.977;
  } else if (118 < score && score <= 119) {
    count = 0.976;
  } else if (119 < score && score <= 120) {
    count = 0.975;
  } else if (120 < score && score <= 121) {
    count = 0.974;
  } else if (121 < score && score <= 122) {
    count = 0.973;
  }
  return count;
};

const year9ProstateArr = [
  [0, "0"],
  [10, "0.100"], // [이전값, 이전 퍼센트값]
  [29, "0.200"], // [위에점수값 ]
  [40, "0.300"],
  [47, "0.400"],
  [54, "0.500"],
  [58, "0.600"],
  [63, "0.700"],
  [66, "0.800"],
  [70, "0.900"],
  [72, "1.000"],
  [75, "1.100"],
  [77, "1.200"],
  [80, "1.300"],
  [82, "1.400"],
  [84, "1.500"],
  [85, "1.600"],
  [87, "1.700"],
  [89, "1.800"],
  [90, "1.900"],
  [91, "2.000"],
  [93, "2.100"],
  [94, "2.200"],
  [95, "2.300"],
  [96, "2.400"],
  [98, "2.500"],
  [99, "2.600"],
  [100, "2.700"],
  [101, "2.800"],
  [102, "2.900"],
  [103, "3.100"],
  [104, "3.200"],
  [105, "3.300"],
  [106, "3.400"],
  [107, "3.500"],
  [108, "3.700"],
  [109, "3.800"],
  [110, "3.900"],
  [111, "4.100"],
  [112, "4.200"],
  [113, "4.400"],
  [114, "4.600"],
  [115, "4.700"],
  [116, "4.900"],
  [117, "5.100"],
  [118, "5.300"],
  [119, "5.500"],
  [120, "5.700"],
  [121, "5.900"],
  [122, "6.100"],
];
export const year9CaseProstate20220511 = (score) => {
  const filterData = year9ProstateArr.filter((data, index) => {
    return score <= data[0];
  });

  if (filterData[0][0] === score) {
    return filterData[0][1].toString();
  } else {
    const nextData = filterData[0]; // 다음 스코어
    const prevData =
      year9ProstateArr[year9ProstateArr.length - filterData.length - 1];
    const preNum = parseFloat(prevData[1]);
    const nextNumData = parseFloat(nextData[1]);
    const totalResult =
      preNum +
      ((nextNumData - preNum) / (nextData[0] - prevData[0])) *
        (score - prevData[0]);
    return totalResult.toFixed(3);
  }
};

//여기
export const prostate9yearCase = (score) => {
  let count = 0.999;
  if (score <= 10) {
    count = 0.999;
  } else if (10 < score && score <= 29) {
    count = 0.998;
  } else if (29 < score && score <= 40) {
    count = 0.997;
  } else if (40 < score && score <= 47) {
    count = 0.996;
  } else if (47 < score && score <= 54) {
    count = 0.995;
  } else if (54 < score && score <= 58) {
    count = 0.994;
  } else if (58 < score && score <= 63) {
    count = 0.993;
  } else if (63 < score && score <= 66) {
    count = 0.992;
  } else if (66 < score && score <= 70) {
    count = 0.991;
  } else if (70 < score && score <= 72) {
    count = 0.99;
  } else if (72 < score && score <= 75) {
    count = 0.989;
  } else if (75 < score && score <= 77) {
    count = 0.988;
  } else if (77 < score && score <= 80) {
    count = 0.987;
  } else if (80 < score && score <= 82) {
    count = 0.986;
  } else if (82 < score && score <= 84) {
    count = 0.985;
  } else if (84 < score && score <= 85) {
    count = 0.984;
  } else if (85 < score && score <= 87) {
    count = 0.983;
  } else if (87 < score && score <= 89) {
    count = 0.982;
  } else if (89 < score && score <= 90) {
    count = 0.981;
  } else if (90 < score && score <= 91) {
    count = 0.98;
  } else if (91 < score && score <= 93) {
    count = 0.979;
  } else if (93 < score && score <= 94) {
    count = 0.978;
  } else if (94 < score && score <= 95) {
    count = 0.977;
  } else if (95 < score && score <= 96) {
    count = 0.976;
  } else if (96 < score && score <= 98) {
    count = 0.975;
  } else if (98 < score && score <= 99) {
    count = 0.974;
  } else if (99 < score && score <= 100) {
    count = 0.973;
  } else if (100 < score && score <= 101) {
    count = 0.972;
  } else if (101 < score && score <= 102) {
    count = 0.971;
  } else if (102 < score && score <= 103) {
    count = 0.969;
  } else if (103 < score && score <= 104) {
    count = 0.968;
  } else if (104 < score && score <= 105) {
    count = 0.967;
  } else if (105 < score && score <= 106) {
    count = 0.966;
  } else if (106 < score && score <= 107) {
    count = 0.965;
  } else if (107 < score && score <= 108) {
    count = 0.963;
  } else if (108 < score && score <= 109) {
    count = 0.962;
  } else if (109 < score && score <= 110) {
    count = 0.961;
  } else if (110 < score && score <= 111) {
    count = 0.959;
  } else if (111 < score && score <= 112) {
    count = 0.958;
  } else if (112 < score && score <= 113) {
    count = 0.956;
  } else if (113 < score && score <= 114) {
    count = 0.954;
  } else if (114 < score && score <= 115) {
    count = 0.953;
  } else if (115 < score && score <= 116) {
    count = 0.951;
  } else if (116 < score && score <= 117) {
    count = 0.949;
  } else if (117 < score && score <= 118) {
    count = 0.947;
  } else if (118 < score && score <= 119) {
    count = 0.945;
  } else if (119 < score && score <= 120) {
    count = 0.943;
  } else if (120 < score && score <= 121) {
    count = 0.941;
  } else if (121 < score && score <= 122) {
    count = 0.939;
  }

  return count;
};

/* 
  폐암 스코어링

*/
export const lungRiskCaculation = (score) => {
  // 년도 데이터
  const yearData = {
    y1: yearOneCase(score),
    y2: yearTwoCase(score),
    y3: yearThreeCase(score),
    y4: yearFourCase(score),
    y5: yearFiveCase(score),
    y6: 0,
    y7: 0,
    y8: 0,
    y9: 0,
  };

  return yearData;
};

/* 
  폐암 스코어링

*/
export const prostateRiskCaculation = (score) => {
  // 년도 데이터
  const yearData = {
    y1: prostate1yearCase(score),
    y2: prostate2yearCase(score),
    y3: prostate3yearCase(score),
    y4: prostate4yearCase(score),
    y5: prostate5yearCase(score),
    y6: 0,
    y7: 0,
    y8: 0,
    y9: 0,
  };

  return yearData;
};

const lungData = {
  total: 28628,
  manTotal: 19524,
  womanTotal: 9104,
  ageData: [
    {
      name: "0~4세",
      man: 0,
      woman: 1,
    },
    {
      name: "5~9세",
      man: 0,
      woman: 0,
    },
    {
      name: "10~14세",
      man: 0,
      woman: 0,
    },
    {
      name: "15~19세",
      man: 1,
      woman: 2,
    },
    {
      name: "20~24세",
      man: 4,
      woman: 7,
    },
    {
      name: "25~29세",
      man: 16,
      woman: 9,
    },
    {
      name: "30~34세",
      man: 20,
      woman: 30,
    },
    {
      name: "35~39세",
      man: 87,
      woman: 73,
    },
    {
      name: "40~44세",
      man: 148,
      woman: 156,
    },
    {
      name: "45~49세",
      man: 361,
      woman: 331,
    },
    {
      name: "50~54세",
      man: 769,
      woman: 575,
    },
    {
      name: "55~59세",
      man: 1526,
      woman: 959,
    },
    {
      name: "60~64세",
      man: 2569,
      woman: 1256,
    },
    {
      name: "65~69세",
      man: 3259,
      woman: 1092,
    },
    {
      name: "70~74세",
      man: 3424,
      woman: 1201,
    },
    {
      name: "75~79세",
      man: 3857,
      woman: 1400,
    },
    {
      name: "80~84세",
      man: 2385,
      woman: 1086,
    },
    {
      name: "85세이상",
      man: 1097,
      woman: 926,
    },
  ],
};

const prostateData = {
  total: 14857,
  manTotal: 14857,
  womanTotal: 0,
  ageData: [
    {
      name: "0~4세",
      man: 0,
      woman: 0,
    },
    {
      name: "5~9세",
      man: 0,
      woman: 0,
    },
    {
      name: "10~14세",
      man: 0,
      woman: 0,
    },
    {
      name: "15~19세",
      man: 1,
      woman: 0,
    },
    {
      name: "20~24세",
      man: 4,
      woman: 0,
    },
    {
      name: "25~29세",
      man: 16,
      woman: 0,
    },
    {
      name: "30~34세",
      man: 20,
      woman: 0,
    },
    {
      name: "35~39세",
      man: 87,
      woman: 0,
    },
    {
      name: "40~44세",
      man: 148,
      woman: 0,
    },
    {
      name: "45~49세",
      man: 361,
      woman: 0,
    },
    {
      name: "50~54세",
      man: 769,
      woman: 0,
    },
    {
      name: "55~59세",
      man: 1526,
      woman: 0,
    },
    {
      name: "60~64세",
      man: 2569,
      woman: 0,
    },
    {
      name: "65~69세",
      man: 3259,
      woman: 0,
    },
    {
      name: "70~74세",
      man: 3424,
      woman: 0,
    },
    {
      name: "75~79세",
      man: 3857,
      woman: 0,
    },
    {
      name: "80~84세",
      man: 2385,
      woman: 0,
    },
    {
      name: "85세이상",
      man: 1097,
      woman: 0,
    },
  ],
};

export const prostateAgeChecker = (age, sex = true) => {
  let title = null;
  let per = 0.0;
  if (0 <= age && age < 5) {
    title = prostateData.ageData[0];
  } else if (5 <= age && age < 10) {
    title = prostateData.ageData[1];
  } else if (10 <= age && age < 15) {
    title = prostateData.ageData[2];
  } else if (15 <= age && age < 20) {
    title = prostateData.ageData[3];
  } else if (20 <= age && age < 25) {
    title = prostateData.ageData[4];
  } else if (25 <= age && age < 30) {
    title = prostateData.ageData[5];
  } else if (30 <= age && age < 35) {
    title = prostateData.ageData[6];
  } else if (35 <= age && age < 40) {
    title = prostateData.ageData[7];
  } else if (40 <= age && age < 45) {
    title = prostateData.ageData[8];
  } else if (45 <= age && age < 50) {
    title = prostateData.ageData[9];
  } else if (50 <= age && age < 55) {
    title = prostateData.ageData[10];
  } else if (55 <= age && age < 60) {
    title = prostateData.ageData[11];
  } else if (60 <= age && age < 65) {
    title = prostateData.ageData[12];
  } else if (70 <= age && age < 70) {
    title = prostateData.ageData[13];
  } else if (75 <= age && age < 75) {
    title = prostateData.ageData[14];
  } else if (75 <= age && age < 80) {
    title = prostateData.ageData[15];
  } else if (80 <= age && age < 85) {
    title = prostateData.ageData[16];
  } else {
    title = prostateData.ageData[17];
  }
  if (sex) {
    per = (title.man / prostateData.total) * 100;
  } else {
    per = (title.woman / prostateData.total) * 100;
  }
  return per;
};

export const newbreastAgeChecker = (age, sex = true) => {
  let title = null;
  let per = 0.0;
  if (0 <= age && age < 5) {
    title = prostateData.ageData[0];
  } else if (5 <= age && age < 10) {
    title = prostateData.ageData[1];
  } else if (10 <= age && age < 15) {
    title = prostateData.ageData[2];
  } else if (15 <= age && age < 20) {
    title = prostateData.ageData[3];
  } else if (20 <= age && age < 25) {
    title = prostateData.ageData[4];
  } else if (25 <= age && age < 30) {
    title = prostateData.ageData[5];
  } else if (30 <= age && age < 35) {
    title = prostateData.ageData[6];
  } else if (35 <= age && age < 40) {
    title = prostateData.ageData[7];
  } else if (40 <= age && age < 45) {
    title = prostateData.ageData[8];
  } else if (45 <= age && age < 50) {
    title = prostateData.ageData[9];
  } else if (50 <= age && age < 55) {
    title = prostateData.ageData[10];
  } else if (55 <= age && age < 60) {
    title = prostateData.ageData[11];
  } else if (60 <= age && age < 65) {
    title = prostateData.ageData[12];
  } else if (70 <= age && age < 70) {
    title = prostateData.ageData[13];
  } else if (75 <= age && age < 75) {
    title = prostateData.ageData[14];
  } else if (75 <= age && age < 80) {
    title = prostateData.ageData[15];
  } else if (80 <= age && age < 85) {
    title = prostateData.ageData[16];
  } else {
    title = prostateData.ageData[17];
  }
  if (sex) {
    per = (title.man / prostateData.total) * 100;
  } else {
    per = (title.woman / prostateData.total) * 100;
  }
  return per;
};

export const lungAgeChecker = (age, sex = true) => {
  let title = null;
  let per = 0.0;
  if (0 <= age && age < 5) {
    title = lungData.ageData[0];
  } else if (5 <= age && age < 10) {
    title = lungData.ageData[1];
  } else if (10 <= age && age < 15) {
    title = lungData.ageData[2];
  } else if (15 <= age && age < 20) {
    title = lungData.ageData[3];
  } else if (20 <= age && age < 25) {
    title = lungData.ageData[4];
  } else if (25 <= age && age < 30) {
    title = lungData.ageData[5];
  } else if (30 <= age && age < 35) {
    title = lungData.ageData[6];
  } else if (35 <= age && age < 40) {
    title = lungData.ageData[7];
  } else if (40 <= age && age < 45) {
    title = lungData.ageData[8];
  } else if (45 <= age && age < 50) {
    title = lungData.ageData[9];
  } else if (50 <= age && age < 55) {
    title = lungData.ageData[10];
  } else if (55 <= age && age < 60) {
    title = lungData.ageData[11];
  } else if (60 <= age && age < 65) {
    title = lungData.ageData[12];
  } else if (70 <= age && age < 70) {
    title = lungData.ageData[13];
  } else if (75 <= age && age < 75) {
    title = lungData.ageData[14];
  } else if (75 <= age && age < 80) {
    title = lungData.ageData[15];
  } else if (80 <= age && age < 85) {
    title = lungData.ageData[16];
  } else {
    title = lungData.ageData[17];
  }
  if (sex) {
    per = (title.man / lungData.total) * 100;
  } else {
    per = (title.woman / lungData.total) * 100;
  }
  return per;
};

// 9년내 비슷한 연령 발생확률
export const newlungAgeChecker = (age, sex = true) => {
  let per = 0.0;

  if (sex) {
    if (40 <= age && age <= 49) {
      per = 0.263;
    } else if (50 <= age && age <= 59) {
      per = 1.028;
    } else if (60 <= age && age <= 69) {
      per = 2.951;
    } else if (70 <= age && age <= 79) {
      per = 5.426;
    } else if (80 <= age && age <= 89) {
      per = 6.089;
    } else if (90 <= age) {
      per = 6.089;
    }
  } else {
    if (40 <= age && age <= 49) {
      per = 0.239;
    } else if (50 <= age && age <= 59) {
      per = 0.464;
    } else if (60 <= age && age <= 69) {
      per = 0.832;
    } else if (70 <= age && age <= 79) {
      per = 1.351;
    } else if (80 <= age && age <= 89) {
      per = 1.729;
    } else if (90 <= age) {
      per = 1.729;
    }
  }
  return per;
};

// 9년내 비슷한 연령 발생확률
export const newDefaultbreastAgeChecker = (age, sex = true) => {
  let per = 0.0;

  if (sex) {
    if (40 <= age && age <= 49) {
      per = 0.263;
    } else if (50 <= age && age <= 59) {
      per = 1.028;
    } else if (60 <= age && age <= 69) {
      per = 2.951;
    } else if (70 <= age && age <= 79) {
      per = 5.426;
    } else if (80 <= age && age <= 89) {
      per = 6.089;
    } else if (90 <= age) {
      per = 6.089;
    }
  } else {
    if (40 <= age && age <= 49) {
      per = 0.239;
    } else if (50 <= age && age <= 59) {
      per = 0.464;
    } else if (60 <= age && age <= 69) {
      per = 0.832;
    } else if (70 <= age && age <= 79) {
      per = 1.351;
    } else if (80 <= age && age <= 89) {
      per = 1.729;
    } else if (90 <= age) {
      per = 1.729;
    }
  }
  return per;
};

//위험요인이 없는경우 폐암 발생 확률
export const newDefaultlungAgeChecker = (age, sex = true) => {
  let per = 0.0;

  if (sex) {
    if (40 <= age && age <= 49) {
      per = "0.140";
    } else if (50 <= age && age <= 59) {
      per = 0.493;
    } else if (60 <= age && age <= 69) {
      per = 1.171;
    } else if (70 <= age && age <= 79) {
      per = 2.067;
    } else if (80 <= age && age <= 89) {
      per = "2.400";
    } else if (90 <= age) {
      per = "2.400";
    }
  } else {
    if (40 <= age && age <= 49) {
      per = 0.007;
    } else if (50 <= age && age <= 59) {
      per = 0.288;
    } else if (60 <= age && age <= 69) {
      per = 0.673;
    } else if (70 <= age && age <= 79) {
      per = 1.171;
    } else if (80 <= age && age <= 89) {
      per = 1.36;
    } else if (90 <= age) {
      per = 1.36;
    }
  }
  return per;
};

//위험요인이 없는경우 폐암 발생 확률
export const newDefaultProstateAgeChecker = (age, sex = true) => {
  let per = 0.0;
  if (40 <= age && age <= 49) {
    per = "0.010";
  } else if (50 <= age && age <= 59) {
    per = 0.457;
  } else if (60 <= age && age <= 69) {
    per = "1.600";
  } else if (70 <= age && age <= 79) {
    per = "2.500";
  } else if (80 <= age) {
    per = "2.700";
  }
  return per;
};

export const newProstateAgeChecker = (age, sex = true) => {
  let per = 0.0;
  if (40 <= age && age <= 49) {
    per = 0.124;
  } else if (50 <= age && age <= 59) {
    per = 0.783;
  } else if (60 <= age && age <= 69) {
    per = 2.774;
  } else if (70 <= age && age <= 79) {
    per = 4.132;
  } else if (80 <= age) {
    per = 4.265;
  }
  return per;
};

export const heightChecker = (num) => {
  let leng = 3;
  if (num < 0.1) {
    leng = 3;
  } else if (0.1 <= num && num < 0.125) {
    leng = 6;
  } else if (0.125 <= num && num < 0.15) {
    leng = 9;
  } else if (0.15 <= num && num < 0.2) {
    leng = 12;
  } else if (0.2 <= num && num < 0.25) {
    leng = 15;
  } else if (0.25 <= num && num < 0.3) {
    leng = 18;
  } else if (0.3 <= num && num < 0.35) {
    leng = 21;
  } else if (0.35 <= num && num < 0.4) {
    leng = 24;
  } else if (0.4 <= num && num < 0.5) {
    leng = 27;
  } else if (0.5 <= num && num < 0.6) {
    leng = 30;
  } else if (0.6 <= num && num < 0.7) {
    leng = 33;
  } else if (0.7 <= num && num < 0.8) {
    leng = 36;
  } else if (0.8 <= num && num < 0.9) {
    leng = 39;
  } else if (0.9 <= num && num < 1) {
    leng = 42;
  } else if (1 <= num && num < 1.5) {
    leng = 45;
  } else if (1.5 <= num && num < 2) {
    leng = 48;
  } else if (2 <= num && num < 3) {
    leng = 51;
  } else if (3 <= num && num < 4) {
    leng = 54;
  } else if (4 <= num && num < 5) {
    leng = 57;
  } else if (5 <= num) {
    leng = 60;
  }
  return leng;
};

export const heightCheckermm = (num) => {
  let leng = 1;
  const mm = "mm";
  if (num < 0.1) {
    leng = 1 + mm;
  } else if (0.1 <= num && num < 0.125) {
    leng = 2 + mm;
  } else if (0.125 <= num && num < 0.15) {
    leng = 3 + mm;
  } else if (0.15 <= num && num < 0.2) {
    leng = 4 + mm;
  } else if (0.2 <= num && num < 0.25) {
    leng = 5 + mm;
  } else if (0.25 <= num && num < 0.3) {
    leng = 6 + mm;
  } else if (0.3 <= num && num < 0.35) {
    leng = 7 + mm;
  } else if (0.35 <= num && num < 0.4) {
    leng = 8 + mm;
  } else if (0.4 <= num && num < 0.5) {
    leng = 9 + mm;
  } else if (0.5 <= num && num < 0.6) {
    leng = 10 + mm;
  } else if (0.6 <= num && num < 0.7) {
    leng = 11 + mm;
  } else if (0.7 <= num && num < 0.8) {
    leng = 12 + mm;
  } else if (0.8 <= num && num < 0.9) {
    leng = 13 + mm;
  } else if (0.9 <= num && num < 1) {
    leng = 14 + mm;
  } else if (1 <= num && num < 1.5) {
    leng = 15 + mm;
  } else if (1.5 <= num && num < 2) {
    leng = 16 + mm;
  } else if (2 <= num && num < 3) {
    leng = 17 + mm;
  } else if (3 <= num && num < 4) {
    leng = 18 + mm;
  } else if (4 <= num && num < 5) {
    leng = 19 + mm;
  } else if (5 <= num) {
    leng = 20 + mm;
  }
  return leng;
};

export const year9CaseFirst = (score) => {
  let count = 0.998;
  if (score <= 30) {
    count = 0.998;
  } else if (30 < score && score <= 55) {
    count = 0.996;
  } else if (55 < score && score <= 70) {
    count = 0.994;
  } else if (70 < score && score <= 81) {
    count = 0.992;
  } else if (81 < score && score <= 89) {
    count = 0.99;
  } else if (89 < score && score <= 96) {
    count = 0.988;
  } else if (96 < score && score <= 101) {
    count = 0.986;
  } else if (101 < score && score <= 106) {
    count = 0.984;
  } else if (106 < score && score <= 111) {
    count = 0.982;
  } else if (111 < score && score <= 115) {
    count = 0.98;
  } else if (115 < score && score <= 118) {
    count = 0.978;
  } else if (118 < score && score <= 121) {
    count = 0.976;
  } else if (121 < score && score <= 124) {
    count = 0.974;
  } else if (124 < score && score <= 127) {
    count = 0.972;
  } else if (127 < score && score <= 130) {
    count = 0.97;
  } else if (130 < score && score <= 132) {
    count = 0.968;
  } else if (132 < score && score <= 134) {
    count = 0.966;
  } else if (134 < score && score <= 137) {
    count = 0.964;
  } else if (137 < score && score <= 139) {
    count = 0.962;
  } else if (139 < score && score <= 140) {
    count = 0.96;
  } else if (140 < score && score <= 142) {
    count = 0.958;
  } else if (142 < score && score <= 144) {
    count = 0.956;
  } else if (144 < score && score <= 146) {
    count = 0.954;
  } else if (146 < score && score <= 147) {
    count = 0.952;
  } else if (147 < score && score <= 149) {
    count = 0.95;
  } else if (149 < score && score <= 150) {
    count = 0.948;
  } else if (150 < score && score <= 152) {
    count = 0.946;
  } else if (152 < score && score <= 153) {
    count = 0.944;
  } else if (153 < score && score <= 154) {
    count = 0.942;
  } else if (154 < score && score <= 156) {
    count = 0.94;
  } else if (156 < score && score <= 157) {
    count = 0.938;
  } else if (157 < score && score <= 158) {
    count = 0.936;
  } else if (158 < score && score <= 159) {
    count = 0.934;
  } else if (159 < score && score <= 160) {
    count = 0.932;
  } else if (160 < score && score <= 162) {
    count = 0.93;
  } else if (162 < score && score <= 163) {
    count = 0.928;
  } else if (163 < score && score <= 164) {
    count = 0.926;
  } else if (164 < score && score <= 165) {
    count = 0.924;
  } else if (165 < score && score <= 166) {
    count = 0.922;
  } else if (166 < score && score <= 167) {
    count = 0.92;
  } else if (167 < score && score <= 168) {
    count = 0.918;
  } else if (168 < score && score <= 169) {
    count = 0.914;
  } else if (169 < score && score <= 170) {
    count = 0.912;
  } else if (170 < score && score <= 171) {
    count = 0.91;
  } else if (171 < score && score <= 172) {
    count = 0.908;
  } else if (172 < score && score <= 173) {
    count = 0.906;
  } else if (173 < score && score <= 174) {
    count = 0.904;
  } else if (174 < score && score <= 175) {
    count = 0.9;
  } else if (175 < score && score <= 176) {
    count = 0.898;
  } else if (176 < score && score <= 177) {
    count = 0.896;
  } else if (177 < score && score <= 178) {
    count = 0.892;
  } else if (178 < score && score <= 179) {
    count = 0.89;
  } else if (179 < score && score <= 180) {
    count = 0.886;
  } else if (180 < score && score <= 181) {
    count = 0.884;
  } else if (181 < score && score <= 182) {
    count = 0.88;
  } else if (182 < score && score <= 183) {
    count = 0.878;
  } else if (183 < score && score <= 184) {
    count = 0.874;
  } else if (184 < score && score <= 185) {
    count = 0.872;
  } else if (185 < score && score <= 186) {
    count = 0.868;
  } else if (186 < score && score <= 187) {
    count = 0.864;
  } else if (187 < score && score <= 188) {
    count = 0.86;
  } else if (188 < score && score <= 189) {
    count = 0.858;
  } else if (189 < score && score <= 190) {
    count = 0.854;
  } else if (190 < score && score <= 191) {
    count = 0.85;
  } else if (191 < score && score <= 192) {
    count = 0.846;
  } else if (192 < score && score <= 193) {
    count = 0.842;
  } else if (193 < score && score <= 194) {
    count = 0.838;
  } else if (194 < score && score <= 195) {
    count = 0.834;
  } else if (195 < score && score <= 196) {
    count = 0.83;
  } else if (196 < score && score <= 197) {
    count = 0.826;
  } else if (197 < score && score <= 198) {
    count = 0.822;
  } else if (198 < score && score <= 199) {
    count = 0.816;
  } else if (199 < score && score <= 200) {
    count = 0.812;
  } else if (200 < score && score <= 201) {
    count = 0.808;
  } else if (201 < score && score <= 202) {
    count = 0.802;
  } else if (202 < score && score <= 203) {
    count = 0.798;
  } else if (203 < score && score <= 204) {
    count = 0.792;
  } else if (204 < score && score <= 205) {
    count = 0.788;
  } else if (205 < score && score <= 206) {
    count = 0.782;
  } else if (206 < score && score <= 207) {
    count = 0.778;
  } else if (207 < score && score <= 208) {
    count = 0.772;
  } else if (208 < score && score <= 209) {
    count = 0.766;
  } else if (209 < score && score <= 210) {
    count = 0.76;
  } else if (210 < score && score <= 211) {
    count = 0.756;
  } else if (211 < score && score <= 212) {
    count = 0.75;
  } else if (212 < score && score <= 213) {
    count = 0.744;
  } else if (213 < score && score <= 214) {
    count = 0.738;
  } else if (214 < score && score <= 215) {
    count = 0.73;
  } else if (215 < score && score <= 216) {
    count = 0.724;
  } else if (216 < score && score <= 217) {
    count = 0.718;
  } else if (217 < score && score <= 218) {
    count = 0.712;
  } else if (218 < score && score <= 219) {
    count = 0.704;
  } else if (219 < score && score <= 220) {
    count = 0.698;
  } else if (220 < score && score <= 221) {
    count = 0.692;
  } else if (221 < score && score <= 222) {
    count = 0.684;
  } else if (222 < score && score <= 223) {
    count = 0.678;
  } else if (223 < score && score <= 224) {
    count = 0.67;
  } else if (224 < score && score <= 225) {
    count = 0.662;
  } else if (225 < score && score <= 226) {
    count = 0.654;
  } else if (226 < score && score <= 227) {
    count = 0.648;
  } else if (227 < score && score <= 228) {
    count = 0.64;
  } else if (228 < score && score <= 229) {
    count = 0.632;
  } else if (229 < score && score <= 230) {
    count = 0.624;
  } else if (230 < score && score <= 231) {
    count = 0.616;
  }
  return count;
};


const breastDataTableY = [
  [381,5.5],
  [380,5.4],
  [378,5.3],
  [376,5.2],
  [375,5.1],
  [373,5],
  [371,4.9],
  [369,4.8],
  [367,4.7],
  [365,4.6],
  [363,4.5],
  [361,4.4],
  [359,4.3],
  [357,4.2],
  [355,4.1],
  [353,4],
  [351,3.9],
  [348,3.8],
  [346,3.7],
  [343,3.6],
  [341,3.5],
  [338,3.4],
  [336,3.3],
  [333,3.2],
  [330,3.1],
  [327,3],
  [324,2.9],
  [321,2.8],
  [318,2.7],
  [315,2.6],
  [311,2.5],
  [308,2.4],
  [304,2.3],
  [300,2.2],
  [296,2.1],
  [292,2],
  [287,1.9],
  [283,1.8],
  [278,1.7],
  [273,1.6],
  [267,1.5],
  [261,1.4],
  [255,1.3],
  [249,1.2],
  [241,1.1],
  [234,1],
  [225,0.9],
  [215,0.8],
  [205,0.7],
  [193,0.6],
  [179,0.5],
  [163,0.4],
  [143,0.3],
  [117,0.2],
  [80,0.1],
  [18,0.1]
].reverse();

const breastDataTableN = [
  [419,4.9],
  [416,4.8],
  [413,4.7],
  [409,4.6],
  [406,4.5],
  [402,4.4],
  [399,4.3],
  [395,4.2],
  [391,4.1],
  [387,4],
  [383,3.9],
  [379,3.8],
  [375,3.7],
  [371,3.6],
  [366,3.5],
  [362,3.4],
  [357,3.3],
  [352,3.2],
  [347,3.1],
  [342,3],
  [337,2.9],
  [331,2.8],
  [325,2.7],
  [319,2.6],
  [313,2.5],
  [307,2.4],
  [300,2.3],
  [293,2.2],
  [286,2.1],
  [278,2],
  [270,1.9],
  [262,1.8],
  [253,1.7],
  [244,1.6],
  [234,1.5],
  [223,1.4],
  [211,1.3],
  [199,1.2],
  [185,1.1],
  [170,1],
  [154,0.9],
  [136,0.8],
  [115,0.7],
  [91,0.6],
  [63,0.5],
  [28,0.4]
].reverse();

const breastDataTableAgeGroup = [
  [41,0.00784],
  [43,0.00898],
  [45,0.00890],
  [47,0.00867],
  [49,0.00843],
  [51,0.00731],
  [53,0.00735],
  [55,0.0066],
  [57,0.00617],
  [59,0.00599],
  [61,0.00594],
  [63,0.00557],
  [65,0.00519],
  [67,0.00464],
  [69,0.00430],
  [71,0.00374],
  [73,0.00363],
  [75,0.00266],
  [77,0.00256],
  [79,0.00177],
  [999,0.00182]
];

export const getBreastCancerScore = (score, menopause) =>
{
  const table = (menopause ? breastDataTableY : breastDataTableN);

  let bmi = score.kg / Math.pow(score.cm / 100, 2);

  let total = 0;

  let rate = 0; 

  let rateAgeGroup = 0;

  if(menopause)
  {
    total = (score.age <= 49 ? 33 : score.age <= 54 ? 22 : score.age <= 59 ? 16 : score.age <= 64 ? 11 : score.age <= 69 ? 5 : 0) +
      (bmi < 18.5 ? 0 : bmi < 23 ? 51 : bmi < 25 ? 64 : bmi < 30 ? 78 : 100) +
      (score.dmyn ? 7 : 0) +
      (score.hbp ? 6 : 0) +
      (score.dyslip ? 5 : 0) +
      (score.brsmoking ? 4 : 0) +
      (score.drinking ? 0 : 0) +
      (score.exercise ? 0 : 0) +
      (score.childbirth == 2 ? 0 : score.childbirth == 1 ? 13 : 12) +
      (score.breastFeeding == 3 ? 0 : score.breastFeeding == 2 ? 12 : score.breastFeeding == 1 ? 20 : 27) +
      (score.mensesAge >= 17 ? 0 : score.mensesAge >= 15 ? 10 : score.mensesAge >= 13 ? 15 : 31) +
      (score.tumor == 1 ? 35 : 0) +
      (score.bpd == 4 ? 73 : score.bpd == 3 ? 59 : score.bpd == 2 ? 38 : score.bpd == 1 ? 0 : 59) +
      (score.menopauseAge >= 55 ? 53 : score.menopauseAge >= 50 ? 34 : score.menopauseAge >= 45 ? 18 : score.menopauseAge >= 40 ? 0 : 18) +
      (score.menopauseHormone ? 22 : 0) +
      (score.bcfmh ? 34 : 0);
  }

  else
  {
    total = (score.age <= 40 ? 0 : score.age <= 45 ? 4 : 8) +
      (bmi < 18.5 ? 0 : bmi < 23 ? 13 : bmi < 25 ? 17 : bmi < 30 ? 24 : 34) +
      (score.dmyn ? 0 : 10) +
      (score.hbp ? 9 : 0) +
      (score.dyslip ? 6 : 0) +
      (score.brsmoking ? 5 : 0) +
      (score.drinking ? 0 : 6) +
      (score.exercise ? 1 : 0) +
      (score.childbirth == 2 ? 0 : score.childbirth == 1 ? 18 : 23) +
      (score.breastFeeding == 3 ? 0 : score.breastFeeding == 2 ? 11 : score.breastFeeding == 1 ? 25 : 29) +
      (score.mensesAge >= 17 ? 0 : score.mensesAge >= 15 ? 23 : score.mensesAge >= 13 ? 32 : 47) +
      (score.tumor == 1 ? 59 : 0) +
      (score.bpd == 4 ? 94 : score.bpd == 3 ? 68 : score.bpd == 2 ? 24 : score.bpd == 1 ? 0 : 68) +
      (score.bcfmh ? 100 : 0);
  }

  for(let step of table)
  {
    if(total <= step[0])
    {
      rate = step[1];

      break;
    }
  }

  for(let step of breastDataTableAgeGroup)
  {
    if(score.age <= step[0])
    {
      rateAgeGroup = step[1] * 100;

      break;
    }
  }

  return {
    total,
    rate,
    rateAgeGroup
  }
};